(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  if (!customElements.get('collection-header-text')) {
    class CollectionHeaderText extends HTMLElement {
      connectedCallback() {
        this.inhalt = this.querySelector('.collection-header__inhalt');
        this.knopf = this.querySelector('.collection-header__mehr');
        if (!this.inhalt || !this.knopf) return;
        this.onKlick = () => {
          const offen = this.inhalt.hasAttribute('data-gekuerzt');
          this.inhalt.toggleAttribute('data-gekuerzt', !offen);
          this.knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
          this.knopf.textContent = offen ? this.knopf.dataset.weniger : this.knopf.dataset.mehr;
        };
        this.knopf.addEventListener('click', this.onKlick);
      }
      disconnectedCallback() {
        this.knopf?.removeEventListener('click', this.onKlick);
      }
    }
    customElements.define('collection-header-text', CollectionHeaderText);
  }

  } catch(e) { console.error(e); }
})();
})();
